import React from 'react';
import './_SuccessIcon.scss';

const SuccessIcon: React.FC = () => {
  return (
    <svg viewBox="0 0 62 62" className="icon-check" xmlns="http://www.w3.org/2000/svg">
      <path d="M31.055.643c-16.85 0-30.5 13.65-30.5 30.5s13.65 30.5 30.5 30.5 30.5-13.65 30.5-30.5-13.66-30.5-30.5-30.5zm-4.99 44.05l-11.76-11.77 3.54-3.54 8.23 8.23 18.23-18.23 3.54 3.54z"></path>
    </svg>
  );
};

export default SuccessIcon;
